export default __webpack_public_path__ + "static/media/my-data-icon.e4a93621.svg";